import LoadingIcon from 'src/libs/components/icons/loading';

interface Props {
    isBuffering: boolean;
}

const CustomBuffering: React.FC<Props> = ({ isBuffering }) => {
    return (
        <div
            className={`absolute top-1/2 left-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full bg-white/40 text-white backdrop-blur-md transition-all duration-300 ${
                isBuffering ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
            }`}
        >
            <LoadingIcon width={34} height={34} />
        </div>
    );
};

export default CustomBuffering;

